import type { FaireProductEntity } from "../../entity_types/product";

export const p_63hc4ujenv: FaireProductEntity = {
  token: "p_63hc4ujenv",
  type: "product",
  name: "Bitchcraft  - Womens Crew Folded",
  brandToken: "b_a48yhkcyr1",
  brandName: "Crazy Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/e2d03a8f969067a91108ee9a820cedd83c2ec177cb4d435dc55aca8478a2bbfe.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    "Spice up your sock drawer – where comfort meets cheeky charm! Walk happy, stay sassy.",
  tags: [],
  msrpDollars: 4.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:44.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
